import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
    Email,
    Password,
    People,
    Collections,
    Face6,
    AddAPhoto
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const Bio = ({ onSelect }) => {
    const [family, setFamily] = useState("");
    const [alias, setAlias] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [bio, setBio] = useState("");
    const [password, setPassword] = useState("");
    const [passwordcon, setPasswordcon] = useState("");
    const [val, setVal] = useState(false); //initializes checkbox to false
    const [posting, setPosting] = useState(false);

    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [detector, setDetector] = useState(null);
    const imgRef = useRef();
    const canvasRef = useRef();

    const webcamRef = useRef(null);
    const [img, setImg] = useState(null);
    const [showWebcam, setShowWebcam] = useState(false);

    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    // Image capture
    const handleCameraClick = () => {
        setShowWebcam(true); // show webcam preview
    };

   const capture = async () => {
  if (!webcamRef.current || !detector) return;

  setLoading(true);

  // Get screenshot
  const imageSrc = webcamRef.current.getScreenshot();

  // Create Image object to ensure it loads before hiding webcam
  const image = new Image();
  image.src = imageSrc;

  image.onload = async () => {
    setImg(imageSrc);      // show preview now
    setShowWebcam(false);  // hide webcam only after image loads

    const canvas = canvasRef.current;
    canvas.width = image.naturalWidth || 300;
    canvas.height = image.naturalHeight || 300;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    // Detect faces
    let faces = [];
    try {
      faces = await detector.estimateFaces(canvas);
    } catch (e) {
      console.error("Face detection failed:", e);
      toast.error("Face detection failed, try again.", { position: "top-center" });
      setLoading(false);
      return;
    }

    if (faces.length !== 1) {
      toast.warn("Failed. Please capture a clear picture showing ONE human face", {
        position: "top-center",
        autoClose: 5000,
      });
      setImg(null); // remove invalid selfie
      setShowWebcam(true); // show webcam again
    } else {
      toast.success("Success. Face detected and accepted", {
        position: "top-center",
        autoClose: 5000,
      });
    }

    setLoading(false);
  };

  image.onerror = () => {
    toast.error("Failed to load captured image. Try again.", { position: "top-center" });
    setImg(null);
    setShowWebcam(true);
    setLoading(false);
  };
};




    const Checkbox = (props) => {
        return (
            <input
                type="checkbox"
                style={{
                    color: "#ddd",
                    alignItems: "center",
                    justifyContent: "left",
                    width: "20px",
                    height: "20px",
                    gap: "4px",
                }}
                checked={props.val}
                onChange={() => {
                    props.setValue(!props.val);
                }}
            />
        );
    };
    const navigate = useNavigate();

    const handleSignUp = async () => {
        if (family === "") {
            toast.warn("Failed. Fill in the family name", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (alias === "") {
            toast.warn("Failed. Fill in your name", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (email === "") {
            toast.warn("Failed. Fill in your email", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (phone === "") {
            toast.warn("Failed. Fill in your phone number", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (password === "") {
            toast.warn("Failed. Fill in your password", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (password !== passwordcon) {
            toast.warn("Failed. Confirm password correctly", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        // if (posting === true) {
        //   return;
        // }

        setPosting(true);
        const baseUrl = apilink.link;

        await axios.get(`${baseUrl}/sanctum/csrf-cookie`, {
            withCredentials: true,
        });

        const dataObj = {
            family,
            alias,
            phone,
            email,
            password,
        };

        console.log(dataObj);


        axios
            .post(`${baseUrl}/family/signup`, dataObj, {
                withCredentials: true, // <-- important for Sanctum
            })
            .then((response) => {
                if (response.data.message === "Family registration successfull") {
                    setPosting(false);
                    setFamily("");
                    setAlias("");
                    setEmail("");
                    setPhone("");
                    setPassword("");
                    setPasswordcon("");
                    setVal(false);
                    toast.success("Family registration successfull. Check email for further instructions", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return;
                } else {
                    setPosting(false);
                    toast.warn(response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return;
                }
            })
            .catch((err) => {
                console.log(err);
                console.log("Error creating post");
            });

        //navigate("/admin");
    };

    const handleMemberSignIn = () => {
        navigate("/");
    };


    const handleUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const dataUrl = event.target.result; // base64 data URL
            setImageUrl(dataUrl);

            // Run detection after image renders
            setTimeout(() => detectFace(dataUrl), 500);
        };
        reader.readAsDataURL(file);
    };


    const detectFace = async (src) => {
        if (!detector) {
            alert("Model still loading…");
            return;
        }

        const canvas = canvasRef.current;
        if (!canvas) return;
        canvas.width = 300;
        canvas.height = 300;
        const ctx = canvas.getContext("2d");

        const image = new Image();
        image.src = src;
        image.onload = async () => {
            try {
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            } catch (e) {
                console.error("drawImage failed:", e);
                return;
            }

            let faces = [];
            try {
                faces = await detector.estimateFaces(canvas);
            } catch (e) {
                console.error("Face detection failed:", e);
            }

            if (faces.length !== 1) {
                toast.warn(
                    "Failed. Please upload a clear picture showing ONE human face",
                    { position: "top-center", autoClose: 5000 }
                );
                setImageUrl(null);
            } else {
                setImg(null);
                setShowWebcam(false);
                toast.success("Success. Face detected and accepted", {
                    position: "top-center",
                    autoClose: 5000,
                });
            }
        };
    };

     const handleChange = async (e) => {
    const value = e.target.value;
    setQuery(value);

    if (!value) {
      setSuggestions([]);
      return;
    }

    // Call Google Places API (or your chosen API)
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${value}&types=(cities)&key=AIzaSyDFviUksfWVs4-bxrYdI44bglRYzRxT-PA`
    );
    const data = await response.json();
    setSuggestions(data.predictions || []);
  };

  const handleSelect = (place) => {
    setQuery(place.description);
    setSuggestions([]);
    onSelect(place); // Send selected place to parent component
  };




    return (
        <>
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "36px",
                    paddingInline: 30,
                }}
            >
                <img
                    alt="logo"
                    style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
                    src={require("./logo.png")}
                />
                <h1
                    className="navbar-brand mb-0"
                    style={{ fontFamily: "Caveat", fontSize: 38 }}
                >
                    <b>Collide - </b> Dating
                </h1>
                <p
                    style={{
                        color: "#010832",
                        fontFamily: "Open Sans",
                        marginTop: "30px",
                    }}
                >
                    Complete Setup
                </p>
                <p
                    style={{
                        color: "#00000090",
                        fontFamily: "Open Sans",
                        marginTop: "10px",
                        fontSize: "12px"
                    }}
                >
                    <center>
                        Almost done. Let people know who you are <br /> and what exactly you are up to
                    </center>
                </p>

                <div style={{
                    textAlign: "center", padding: 20, flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <h6>Upload Profile Picture</h6>

                    {/* Hidden canvas */}
                    <canvas
                        ref={canvasRef}
                        width={300}
                        height={300}
                        style={{ display: "none" }}
                    />

                    {/* Preview */}
                    {imageUrl && (
                        <img
                            ref={imgRef}
                            src={imageUrl}
                            alt="preview"
                            style={{
                                width: 300,
                                height: 300,
                                objectFit: "cover",
                                borderRadius: 12,
                                marginBottom: 10,
                            }}
                            onLoad={detectFace}
                        />
                    )}

                    {loading && <p>Detecting face…</p>}

                    {/*Selfie image*/}
                    {/* Selfie */}
                    {showWebcam ? (
                        <div style={{ position: "relative" }}>
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                videoConstraints={{ facingMode: "user" }}
                                style={{ width: "320px", borderRadius: "10px", border: "2px solid #010832" }}
                            />
                            <button
                                onClick={capture}
                                style={{
                                    position: "absolute",
                                    bottom: 10,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    padding: "8px 16px",
                                    backgroundColor: "#010832",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: 5,
                                    cursor: "pointer"
                                }}
                            >
                                Capture
                            </button>
                        </div>
                    ) : (
                        img ? (
                            <img src={img} alt="Selfie" style={{ width: "320px", borderRadius: "10px" }} />
                        ) : (
                            <></>
                        )
                    )}


                    <div
                        style={{
                            width: "320px",
                            height: "55px",
                            border: "1px solid #010832",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            marginTop: "10px",
                            cursor: "pointer",
                        }}

                    >
                        {/* LEFT ICON AREA */}
                        <div
                            style={{
                                width: "40px",
                                height: "55px",
                                backgroundColor: "#010832",
                                borderTopLeftRadius: "10px",
                                borderBottomLeftRadius: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                            onClick={handleCameraClick}
                        >
                            <AddAPhoto style={{ color: "#ffffff", fontSize: 28 }} />
                        </div>

                        {/* TEXT */}
                        <div
                            style={{
                                flex: 1,
                                textAlign: "center",
                                fontFamily: "Open Sans",
                                fontSize: "12px",
                                color: "#00000080",
                            }}
                        >
                            Choose Profile Picture<br /> Selfie on left, Gallery on right
                        </div>
                        {/* RIGHT ICON AREA */}
                        <div
                            style={{
                                width: "40px",
                                height: "55px",
                                backgroundColor: "#010832",
                                borderTopRightRadius: "10px",
                                borderBottomRightRadius: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                            onClick={() => document.getElementById("profileUpload").click()}
                        >
                            <Collections style={{ color: "#ffffff", fontSize: 28 }} />
                        </div>
                    </div>

                    <input
                        id="profileUpload"
                        type="file"
                        accept="image/*"
                        onChange={handleUpload}
                        style={{ display: "none" }}
                    />

                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 50,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div
                        style={{
                            width: "40px",
                            height: 50,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <People style={{ color: "#ffffff" }} />
                    </div>
                    <div
                        style={{
                            height: 50,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <select
                            style={alias == "" ? {
                                height: 48.7,
                                width: "279.2px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 5,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: "none",
                                color: "gray",
                                backgroundColor: "#ffffff"
                            } : {
                                height: 48.7,
                                width: "279.2px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 5,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: "none",
                                color: "black",
                                backgroundColor: "#ffffff"
                            }}
                            value={alias}
                            maxLength={30}
                            onChange={(e) => {
                                setAlias(e.target.value);
                            }}
                        >
                            <option value="" disabled selected>What are you looking for</option>
                            <option value="Serious relationship">Serious relationship</option>
                            <option value="Short-term relationship">Short-term relationship</option>
                            <option value="Friendship">Friendship</option>
                            <option value="Meeting new people">Meeting new people</option>
                            <option value="Someone to hang out with">Someone to hang out with</option>
                            <option value="Still figuring it out">Still figuring it out</option>
                        </select>

                    </div>
                    <div></div>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 100,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div
                        style={{
                            width: "40px",
                            height: 100,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "right",
                        }}
                    >
                        <Face6 style={{ color: "#ffffff", marginTop: "10px" }} />
                    </div>
                    <div
                        style={{
                            height: 100,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <label style={{
                            backgroundColor: "#ffffff", width: "279.2px", paddingLeft: "10px", color: "#00000085", fontFamily: "Open Sans",
                            fontSize: 14, borderTop: "1px solid #010832", borderTopRightRadius: 5
                        }}>Bio(Let others know more about you)</label>
                        <textarea
                            style={{
                                height: 77,
                                width: "279.2px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 6,
                                border: "1px solid white",
                                borderBottomRightRadius: 5,
                                outlineStyle: "none",
                                backgroundColor: "#ffffff",
                                resize: "none" // prevents dragging to resize
                            }}
                            value={bio}
                            maxLength={200}
                            onChange={(e) => setBio(e.target.value)}
                        />
                    </div>
                    <div></div>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 50,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                     <div style={{ position: "relative" }}>
      <input
        value={query}
        onChange={handleChange}
        placeholder="Enter your city"
        style={{ width: 300, padding: 8 }}
      />
      {suggestions.length > 0 && (
        <ul style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          background: "#fff",
          border: "1px solid #ccc",
          maxHeight: 150,
          overflowY: "auto",
          margin: 0,
          padding: 0,
          listStyle: "none",
          zIndex: 1000
        }}>
          {suggestions.map((s) => (
            <li
              key={s.place_id}
              onClick={() => handleSelect(s)}
              style={{ padding: 8, cursor: "pointer" }}
            >
              {s.description}
            </li>
          ))}
        </ul>
      )}
    </div>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 50,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div
                        style={{
                            width: "40px",
                            height: 50,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Password style={{ color: "#ffffff" }} />
                    </div>
                    <div
                        style={{
                            height: 50,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <input
                            style={{
                                height: 48.8,
                                width: "279.2px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: "none",
                            }}
                            value={passwordcon}
                            placeholder="Confirm Password"
                            type="password"
                            maxLength={20}
                            onChange={(e) => {
                                setPasswordcon(e.target.value);
                            }}
                        />
                    </div>
                    <div></div>
                </div>
                <p
                    style={{
                        color: "#000000",
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        marginTop: "30px",
                        alignSelf: "left",
                        width: "320px",
                    }}
                >
                    <Checkbox value={val} setValue={setVal}></Checkbox>
                    &nbsp;&nbsp;Agree to{" "}
                    <span style={{ color: "#010832" }}>Terms and conditions</span>
                </p>
                <button
                    onClick={() => handleSignUp()}
                    style={{
                        width: "320px",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        border: "none",
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        color: "white",
                        marginTop: "10px",
                    }}
                >
                    {posting === false && <>Proceed</>}
                    {posting && (
                        <>
                            <Squares />
                        </>
                    )}
                </button>

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />

            </div>
        </>
    );
};

export default Bio;
